import { ReducersMapObject } from '@reduxjs/toolkit';

import activate from 'app/modules/account/activate/activate.reducer';
import password from 'app/modules/account/password/password.reducer';
import passwordReset from 'app/modules/account/password-reset/password-reset.reducer';
import settings from 'app/modules/account/settings/settings.reducer';
import administration from 'app/modules/administration/administration.reducer';
import adminAppVersion from 'app/modules/administration/app-version/app-version.reducer';
import adminBookings from 'app/modules/administration/bookings/bookings.reducer';
import adminBusinessDetail from 'app/modules/administration/businesses/business-detail.reducer';
import adminBusinesses from 'app/modules/administration/businesses/businesses.reducer';
import adminCoupons from 'app/modules/administration/coupons/coupons.reducer';
import adminMetrics from 'app/modules/administration/dashboard/dashboard.reducer';
import adminSubscriptions from 'app/modules/administration/subscriptions/subscriptions.reducer';
import userManagement from 'app/modules/administration/user-management/user-management.reducer';
import loadingBar from 'app/shared/reducers/loading-bar';

import applicationProfile from './application-profile';
import authentication from './authentication';

const rootReducer: ReducersMapObject = {
  authentication,
  applicationProfile,
  administration,
  userManagement,
  adminAppVersion,
  adminBookings,
  adminBusinesses,
  adminBusinessDetail,
  adminCoupons,
  adminMetrics,
  adminSubscriptions,
  activate,
  passwordReset,
  password,
  settings,
  loadingBar,
};

export default rootReducer;
